module.exports = __webpack_public_path__ + "img/SPA-img-08.9a986a28.jpg";